import React from 'react'
import { Link } from 'react-router-dom'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputSelectSF from '../../../widgets/form/InputSelectSF'
import InputTextSF from '../../../widgets/form/InputTextSF'
import InputDateUI from '../../../widgets/form/InputDateUI'
import SpinnerUI from '../../../widgets/output/SpinnerUI'

const RecurringTransferCreateModalUI = ({ context, successMsg, errorList, setErrorList,
  createMode, submitted, bankDetailsVerified, onSubmit, onCancelClick, onVerifyBankDetailsClick,
  interval, onIntervalChange, intervalError, setIntervalError, intervalList,
  startDate, onStartDateChange, startDateError, setStartDateError,
  endDate, onEndDateChange, endDateError, setEndDateError,
  dayOfWeek, onDayOfWeekChange, dayOfWeekError, setDayOfWeekError, daysList,
  dayOfMonth, onDayOfMonthChange, dayOfMonthError, setDayOfMonthError, monthList,
  paymentAmount, onPaymentAmountChange, paymentAmountError, setPaymentAmountError,
  ifscCode, onIfscCodeChange, ifscCodeError, setIfscCodeError,
  bankAccountNumber, onBankAccountNumberChange, bankAccountNumberError, setBankAccountNumberError,
}) =>
  <ModalFormUI
    context={context}
    titleLabel='Create standing instructions'
    buttonLabel='Create'
    cancelLabel='Cancel'
    isOpen={createMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    {/* <InputSelectSF
          type='select' name='interval' label='Interval'
          value={interval} onChange={onIntervalChange} optionList={intervalList}
          error={intervalError} setError={setIntervalError}
          required={true}
        /> */}

    {/* {
          interval === 'weekly' &&
          <InputSelectSF
            type='select' name='dayOfWeek' label='Day of week'
            value={dayOfWeek} onChange={onDayOfWeekChange} optionList={daysList}
            error={dayOfWeekError} setError={setDayOfWeekError}
          />
        }

        {
          interval === 'monthly' &&
          <InputSelectSF
            type='select' name='dayOfMonth' label='Day of month'
            value={dayOfMonth} onChange={onDayOfMonthChange} optionList={monthList}
            error={dayOfMonthError} setError={setDayOfMonthError}
          />
        } */}

    <InputTextSF
      type='text' name='bankAccountNumber' label='Bank account number'
      value={bankAccountNumber} onChange={onBankAccountNumberChange}
      error={bankAccountNumberError} setError={setBankAccountNumberError}
      required={true}
    />

    <InputTextSF
      type='text' name='ifscCode' label='IFSC code'
      value={ifscCode} onChange={onIfscCodeChange}
      error={ifscCodeError} setError={setIfscCodeError}
      required={true}
    />

    <div className='g_m_top_100  g_flex_h g_flex_right'>
      <SpinnerUI show={bankDetailsVerified} />
      <Link to='#' onClick={onVerifyBankDetailsClick}>Verify bank account</Link>
    </div>

    <InputTextSF
      type='text' name='paymentAmount' label='Payment amount'
      value={paymentAmount} onChange={onPaymentAmountChange}
      error={paymentAmountError} setError={setPaymentAmountError}
      required={true}
      help='Limit 10 lakhs'
    />

    <InputDateUI context={context} type='date' name='startDate' label='Start date'
      selectedDateISO={startDate} onChange={onStartDateChange}
      error={startDateError} setError={setStartDateError}
      required={true}
      help='Transfers initiated at 4:30pm'
    />

    <InputDateUI context={context} type='date' name='endDate' label='End date'
      selectedDateISO={endDate} onChange={onEndDateChange}
      error={endDateError} setError={setEndDateError}
    />

  </ModalFormUI>

export default RecurringTransferCreateModalUI
